import {
  Injectable,
  computed,
  signal
} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionAccessService {

  // ======================================================
  // STATE
  // ======================================================

  private readonly _blocked =
    signal(false);

  // ======================================================
  // PUBLIC SIGNALS
  // ======================================================

  readonly blocked =
    computed(() =>
      this._blocked()
    );

  // ======================================================
  // METHODS
  // ======================================================

  block(): void {
    this._blocked.set(true);
  }

  unblock(): void {
    this._blocked.set(false);
  }
}